export const BIG_COMMERCE = 'bigcommerce';
export const SHOPIFY = 'shopify';
export const WOO_COMMERCE = 'woocommerce';
export const STANDALONE = 'standalone';

export const CREATE_SOURCE_ERROR = 'CREATE_SOURCE_ERROR';
